// Post-login landing path by role: DIY accounts land on the DIY screen,
// everyone else on the Planner (Session 289).
export function landingPath(userType = localStorage.getItem("compass_user_type")) {
  return userType === "DIY" ? "/DIYWizards" : "/planner";
}
